import styled from 'styled-components';

export const FieldSet = styled.fieldset`
  margin: 0;
  padding: 0;
  border: none;
`;
